<div
  class="sui-date-range-picker"
  [class.sui-date-range-picker--inline]="inline"
  [class.sui-date-range-picker--disabled]="isDisabled()"
>
  @if (inline) {
    <ng-container *ngTemplateOutlet="calendarBody" />
  } @else {
    <!-- Field: read-only "start – end" text + calendar-icon trigger (the icon
         button is the trigger; the popover anchors to the whole field). -->
    <div class="sui-date-range-picker__field" #fieldEl>
      <sui-input
        class="sui-date-range-picker__field-input"
        [readonly]="true"
        [id]="effectiveId"
        [placeholder]="placeholder"
        [disabled]="isDisabled()"
        [ngModel]="inputText()"
        [ngModelOptions]="{ standalone: true }"
      >
        <button
          sui-suffix
          type="button"
          class="sui-date-range-picker__trigger"
          aria-label="Open calendar"
          [suiPopoverTrigger]="calendarTpl"
          [suiPopoverAnchor]="fieldEl"
          [suiPopoverContainer]="resolvedPopoverContainer"
          [suiPopoverTriggerDisabled]="isDisabled()"
        >
          <fa-icon [icon]="faCalendar" />
        </button>
      </sui-input>
    </div>

    <ng-template #calendarTpl>
      <div suiPopover class="sui-date-range-picker__panel">
        <ng-container *ngTemplateOutlet="calendarBody" />
      </div>
    </ng-template>
  }

  <!-- Shared two-month calendar. Each [ngpDateRangePicker] root self-provides its
       state, so this template portals into the popover with no extra DI wiring. -->
  <ng-template #calendarBody>
    <!-- One shared nav header across both months. prev/next drive the focusedMonth
         (left = M, right = M+1); they're not the per-root ngp directives. -->
    <div class="sui-date-range-picker__header">
      <button
        type="button"
        class="sui-date-range-picker__nav"
        [disabled]="prevDisabled()"
        aria-label="Previous month"
        (click)="prevMonth()"
      >
        <fa-icon [icon]="faPrev" />
      </button>

      <span class="sui-date-range-picker__label">{{ leftLabel() }}</span>
      <span class="sui-date-range-picker__label">{{ rightLabel() }}</span>

      <button
        type="button"
        class="sui-date-range-picker__nav"
        [disabled]="nextDisabled()"
        aria-label="Next month"
        (click)="nextMonth()"
      >
        <fa-icon [icon]="faNext" />
      </button>
    </div>

    <!-- Live-region announcing the visible range of months; visually hidden. -->
    <span class="sui-date-range-picker__sr-label" aria-live="polite">
      {{ leftLabel() }} – {{ rightLabel() }}
    </span>

    <div class="sui-date-range-picker__months">
      <!-- Left month (M) -->
      <div
        class="sui-date-range-picker__month"
        ngpDateRangePicker
        [ngpDateRangePickerStartDate]="startInput()"
        [ngpDateRangePickerEndDate]="endInput()"
        [ngpDateRangePickerFocusedDate]="leftFocused()"
        [ngpDateRangePickerMin]="minDate"
        [ngpDateRangePickerMax]="maxDate"
        [ngpDateRangePickerDisabled]="isDisabled()"
        [ngpDateRangePickerDateDisabled]="dateDisabled"
        [ngpDateRangePickerFirstDayOfWeek]="firstDayOfWeek"
        (ngpDateRangePickerStartDateChange)="onStartChange($event)"
        (ngpDateRangePickerEndDateChange)="onEndChange($event)"
        (ngpDateRangePickerFocusedDateChange)="onLeftFocusedChange($event)"
      >
        <sui-calendar
          [showWeekNumbers]="true"
          [compact]="compact"
          [ariaLabel]="leftLabel()"
        />
      </div>

      <!-- Right month (M+1) -->
      <div
        class="sui-date-range-picker__month"
        ngpDateRangePicker
        [ngpDateRangePickerStartDate]="startInput()"
        [ngpDateRangePickerEndDate]="endInput()"
        [ngpDateRangePickerFocusedDate]="rightFocused()"
        [ngpDateRangePickerMin]="minDate"
        [ngpDateRangePickerMax]="maxDate"
        [ngpDateRangePickerDisabled]="isDisabled()"
        [ngpDateRangePickerDateDisabled]="dateDisabled"
        [ngpDateRangePickerFirstDayOfWeek]="firstDayOfWeek"
        (ngpDateRangePickerStartDateChange)="onStartChange($event)"
        (ngpDateRangePickerEndDateChange)="onEndChange($event)"
        (ngpDateRangePickerFocusedDateChange)="onRightFocusedChange($event)"
      >
        <sui-calendar
          [showWeekNumbers]="true"
          [compact]="compact"
          [ariaLabel]="rightLabel()"
        />
      </div>
    </div>
  </ng-template>
</div>
